module.exports = __webpack_public_path__ + "static/media/benefit.06a23f95.svg";